import countdownMixins from '@/mixins/countdown.js'

import { mapActions, mapMutations } from "vuex"

export default {
  mixins: [countdownMixins],
  data() {
    return {
      captcha: '',
    }
  },
  methods: {
    ...mapActions(['getCaptcha', 'getPhoneCode']),
    ...mapMutations(['setTipsDialog']),
    async getCaptchaInfo() {
      const captcha = await this.getCaptcha()
      this.form.captcha_id = captcha.verifyCodeHash
      this.captcha = captcha.verifyCode
    },
    async sendPhoneCode() {
      // 倒计时未结束时不能再发送
      if (this.countdown > 0) return false
      // 判断是否有手机号
      if (!this.form.phone) {
        this.setTipsDialog({ visible: true, tips: '请输入手机号' })
        return false
      }

      this.startCountdown()

      await this.getPhoneCode({ token: this.verifyCodeToken, phone: this.form.phone })
    },
  }
}